/**
 * 表示不進行任何處理的錯誤，用於從深層函式中快速跳出
 */
export class NoopError extends Error {}
